exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._187jn{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%}._1bBl2{font-size:14px;font-weight:400;margin-bottom:7px}._1bJEb{font-weight:400;padding-top:4px}._2YpXN{font-weight:700;font-size:19px}._2YpXN,._39aqy{margin-top:5px;display:inline-block;color:#000}._39aqy{font-weight:400;font-size:14px}._2YpXN small{font-size:70%;font-weight:400}._1Wpcc{background-color:#ffeb3b}", ""]);

// exports
exports.locals = {
	"root": "_187jn",
	"title": "_1bBl2",
	"similarYear": "_1bJEb",
	"similarPrice": "_2YpXN",
	"contractPrice": "_39aqy",
	"emphasizePrice": "_1Wpcc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertCard/SimilarCard/SimilarCard.css
// module id = 1865
// module chunks = 0 20 24 33 36